// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modalCorporate {
  display: flex;
  position: fixed;
  justify-content: center;
  align-items: center;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  margin-left: -35px;
  z-index: 9999;
}

.modalDowload {
  margin-left: -65px;
}

.modal {
  display: flex;
  position: relative;
  flex-direction: column;
  max-width: 540px;
  min-width: 270px;
  min-height: 150px;
  background-color: white;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05);
  z-index: 9999;
}

.titleModal {
  font-size: 17px;
  font-weight: 600;
}

.titleDescription {
  font-size: 17px;
  font-weight: 700;
}

.buttonsEdit {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding-top: 15px;
  gap: 25px;
}

.containerTitleModal {
  padding: 5px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.containerDescription {
  display: flex;
  flex-direction: column;
}

.line {
  background-color: #c1c7cc;
  width: 100%;
  height: 1px;
}

.bodyModal {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  font-size: 17px;
}

.closeButton {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: 16px;
}`, "",{"version":3,"sources":["webpack://./src/componentes/modal/modal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,MAAM;EACN,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,+CAA+C;EAC/C,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,eAAe;AACjB","sourcesContent":[".modalCorporate {\n  display: flex;\n  position: fixed;\n  justify-content: center;\n  align-items: center;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  margin-left: -35px;\n  z-index: 9999;\n}\n\n.modalDowload {\n  margin-left: -65px;\n}\n\n.modal {\n  display: flex;\n  position: relative;\n  flex-direction: column;\n  max-width: 540px;\n  min-width: 270px;\n  min-height: 150px;\n  background-color: white;\n  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05);\n  z-index: 9999;\n}\n\n.titleModal {\n  font-size: 17px;\n  font-weight: 600;\n}\n\n.titleDescription {\n  font-size: 17px;\n  font-weight: 700;\n}\n\n.buttonsEdit {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  padding-top: 15px;\n  gap: 25px;\n}\n\n.containerTitleModal {\n  padding: 5px 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.containerDescription {\n  display: flex;\n  flex-direction: column;\n}\n\n.line {\n  background-color: #c1c7cc;\n  width: 100%;\n  height: 1px;\n}\n\n.bodyModal {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  width: 100%;\n  font-size: 17px;\n}\n\n.closeButton {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  font-size: 16px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
